module.exports = __webpack_public_path__ + "static/media/logo-alt_small.3835b4b1.svg";